import { makeObservable, observable, action, computed } from "mobx";
import {
  ReviewsState,
  waiting,
  loading,
  ready,
  ReviewResource,
  ReviewsResource
} from "./Types";
import { noop } from "../../utils/noop";

class ReviewsStore {
  state: ReviewsState;

  constructor() {
    this.state = waiting();
    makeObservable(this, {
      state: observable,
      loading: action,
      ready: action,
      reviews: computed
    });
  }

  loading = () => {
    this.state = loading();
  };

  ready = (reviewsResource: ReviewsResource) => {
    this.state = ready(reviewsResource);
  };

  get reviews(): ReviewResource[] {
    switch (this.state.kind) {
      case "waiting":
      case "loading":
        return [];
        break;
      case "ready":
        return this.state.reviewsResource.reviews;
        break;
    }
  }
}

export default ReviewsStore;
